import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import { guardarReferido } from '@/Utils/referido';

import AccommodationCharges from '@/pages/Dashboard/AccommodationCharges.vue'

// Routes
import authRoutes from "@/routes/auth";
import accommodationVisit from "@/routes/accommodationVisit";
import publication from "@/routes/publication";
import user from "@/routes/user";
import reservation from "@/routes/reservation";
import searchQueries from "@/routes/searchQuery";
import conversation from "@/routes/conversation";


// Supported languages
import { i18n } from '@/main';
import { supportedLanguages } from '@/config';



import HomeNuevo from '@/pages/General/HomeNuevo'
import About from '@/pages/General/About'
import DetalleAlojamiento from '@/pages/General/DetalleAlojamiento'
import Privacy from '@/pages/General/Privacy'
import Faq from '@/pages/General/Faq'
import TermsConditions from '@/pages/General/TermsConditions'
import Contact from '@/pages/General/Contact'
import Investment from '@/pages/General/Investment'
import Property from '@/pages/General/property'
import PropertyHome from '@/pages/General/PropertyHome'
import Property2 from '@/pages/General/Property2'
import PropertyGuestForm from '@/pages/General/PropertyGuestForm'
import Admin from '@/pages/Dashboard/Admin'
// Intake route removed

import MisAlojamientos from '@/pages/Dashboard/MisAlojamientos';
// Panel del usuario tipo property (dueño de edificio)
import PropertyCalendar from '@/pages/Dashboard/PropertyCalendar'
import Informes from '@/pages/Dashboard/Informes'
import DatosBancarios from './pages/Dashboard/BankInformation.vue'
import EditarPerfil from '@/pages/Dashboard/EditarPerfil'
import Favoritos from '@/pages/Dashboard/Favoritos';
import BlockDates from '@/pages/Dashboard/BlockDates'
import Coupon from '@/pages/Dashboard/Coupon'
import WizardPropiedad from '@/pages/Host/WizardPropiedad'
import WizardUnidades from '@/pages/Host/WizardUnidades'
import ManageData from '@/pages/Dashboard/ManageData'
import DashboardIntake from '@/pages/Dashboard/DashboardIntake.vue'
import Llegada from '@/pages/General/Llegada';
import Highlight from '../src/components/Admin/Highlight/Highlight'
import Visits from '../src/components/Admin/Visits/Visits'
import Reservations from '../src/components/Admin/Reservations/Reservations'
import Ical from '../src/components/Admin/Ical/Ical'
import GenericLink from '../src/components/Admin/GenericLink/GenericLink'
import FacebookDeleteStatus from './components/Facebook/FacebookDeleteStatus'
import EdicionPrecios from '../src/components/Admin/EdicionPrecios/EdicionPrecios'
// Mensajería. Desde 2026-09 hay una sola consola: esta. El dashboard anterior
// (Dashboardmensajeria.vue, con ChatPanel y KanbanBoard) se eliminó, y lo único
// que se rescató de él —los hilos anfitrión ↔ huésped— vive ahora adentro de
// DashboardV2 como una vista más.
import DashboardV2 from '../src/components/Admin/Mensajeria/v2/DashboardV2.vue'
import BackOffice from '../src/components/Admin/BackOffice/BackOffice'
import Permissions from '../src/components/Admin/Permissions/Permissions'
import Modelos from '../src/components/Admin/Modelos/Modelos'
import PropertyAdmin from '../src/components/Admin/Property/Property'
import AdminInformes from '../src/components/Admin/Informes/Informes'

import Success from '@/components/Wizard/Success'

import Reserva from '@/components/Payment/Reserva'
import Payment from '@/components/Payment/Payment';
import PaymentResponse from '@/components/Payment/PaymentResponse'

import qs from 'qs';
import { saveRedirectUrl, saveLastVisitedUrl } from '@/Utils/Utils';

Vue.use(Router)

let router = new Router({
    mode: 'history',
    linkExactActiveClass: 'active',
    base: process.env.BASE_URL,
    // Al navegar a una nueva ruta, subir al inicio de la página.
    // Respeta la posición guardada al usar atrás/adelante y los anclas (#hash).
    scrollBehavior(to, from, savedPosition) {
        // Pantallas que guardan sus filtros en la URL y deciden solas el
        // scroll (p. ej. Oferta disponible): no saltar arriba en cada filtro.
        if (to.meta && to.meta.scrollPropio && from.name === to.name) {
            return false;
        }
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    },
    routes: [
        ...authRoutes,
        ...accommodationVisit,
        ...publication,
        ...user,
        ...reservation,
        ...searchQueries,
        ...conversation,
        {
            path: '/',
            name: 'home',
            component: HomeNuevo,
            // fondo: false → la portada no lleva el fondo de marca del resto del sitio.
            meta: { hideHeader: true, hideFooter: true, fondo: false }
        },
        {
            // Formulario de llegada de una reserva aceptada. Entra por el link
            // del correo, sin login: el token dice si el que abre es el huésped
            // o el anfitrión, y el modelo del anfitrión, cuál de los dos
            // formularios se muestra (ver Llegada.vue).
            path: '/llegada/:idreserva/:token',
            name: 'llegada',
            component: Llegada
        },
        {
            // Agregar un espacio: el mismo editor que Editar (EditarEspacio.vue sin
            // :idalojamiento → POST accommodations/create).
            path: '/registro-alojamiento',
            name: 'registro-alojamiento',
            component: () => import('@/pages/Host/EditarEspacio.vue'),
            meta: {
                requiresAuth: true,
                showDashboard: true,
                hideBot: true
            }
        },
        {
            path: '/host/nueva-propiedad',
            name: 'host-nueva-propiedad',
            component: WizardPropiedad,
            meta: {
                requiresAuth: true,
                showDashboard: true,
                hideBot: true
            }
        },
        {
            path: '/host/cargar-unidades',
            name: 'host-cargar-unidades',
            component: WizardUnidades,
            meta: {
                requiresAuth: true,
                showDashboard: true,
                hideBot: true
            }
        },
        {
            // Editor de alojamiento (una sola página con secciones).
            path: '/editar-alojamiento/:idalojamiento',
            name: 'editar-espacio',
            component: () => import('@/pages/Host/EditarEspacio.vue'),
            meta: {
                requiresAuth: true,
                showDashboard: true
            }
        },
        {
            path: '/editar-varios',
            name: 'editar-varios',
            component: () => import('@/pages/Host/EditarVarios.vue'),
            meta: {
                requiresAuth: true,
                showDashboard: true
            }
        },
        {
            path: '/my-accommodations',
            name: 'my-accommodations',
            component: MisAlojamientos,
            meta: {
                requiresAuth: true,
                showDashboard: true
            }
        },
        {
            // Calendario de ocupación del property: timeline de todos sus
            // alojamientos y calendario mensual de uno, sobre los mismos datos.
            path: '/calendario',
            name: 'property-calendario',
            component: PropertyCalendar,
            meta: {
                requiresAuth: true,
                requiresProperty: true,
                showDashboard: true
            }
        },
        {
            // Archivos que el admin le carga desde /admin/informes.
            path: '/informes',
            name: 'informes',
            component: Informes,
            meta: {
                requiresAuth: true,
                requiresProperty: true,
                showDashboard: true
            }
        },
        {
            path: '/carga-masiva',
            name: 'carga-masiva',
            component: () => import('@/pages/Dashboard/CargaMasiva.vue'),
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'carga-masiva',
                showDashboard: true
            }
        },
        {
            path: '/alojamiento-masivo',
            name: 'alojamiento-masivo',
            component: AccommodationCharges,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'carga-masiva',
                showDashboard: true
            }
        },
        {
            path: '/actualizado_con_exito',
            name: 'Update',
            component: Success,
            props: { update: true },
            meta: {
                requiresAuth: true,
                showDashboard: true
            }
        },
        {
            path: '/editar-perfil',
            name: 'editar-perfil',
            component: EditarPerfil,
            meta: {
                requiresAuth: true,
                showDashboard: true
            }
        },
        {
            path: '/datos-bancarios',
            name: 'Datos bancarios',
            component: DatosBancarios,
            meta: {
                requiresAuth: true,
                showDashboard: true
            }
        },
        {
            path: '/alojamiento/:idalojamiento/:fecha_inicio?/:fecha_termino?',
            name: 'detalle-alojamiento',
            component: DetalleAlojamiento
        },
        {
            path: '/bloquear/:id',
            name: 'Block-Dates',
            component: BlockDates,
            meta: {
                requiresAuth: true,
                showDashboard: true
            }
        },
        {
            path: '/reserva/:action/:id/:token',
            name: 'reserva',
            component: Reserva
        },
        {
            path: '/reserva-status/:status',
            name: 'status-reserva',
            component: PaymentResponse
        },
        {
            path: '/pagos/:id/:token',
            name: 'pagos',
            component: Payment
        },
        {
            path: '/contacto',
            name: 'contact',
            component: Contact
        },
        {
            // Formulario de búsqueda.
            path: '/formulario',
            name: 'formulario',
            component: () => import('@/pages/General/FormularioNuevo.vue')
        },
        {
            path: '/property-huesped',
            name: 'property-huesped',
            component: PropertyGuestForm
        },
        {
            path: '/investment',
            name: 'investment',
            component: Investment
        },
        {
            path: '/property',
            name: 'property',
            component: Property
        },
        {
            path: '/propertyhome',
            name: 'propertyhome',
            component: PropertyHome,
            meta: {
                hideHeader: true,
                hideFooter: true
            }
        },
        {
            path: '/propertyy',
            name: 'propertyy',
            component: Property2,
            meta: {
                hideHeader: true,
                hideFooter: true
            }
        },
        {
            path: '/about',
            name: 'about',
            component: About
        },
        {
            path: '/favoritos',
            name: 'favoritos',
            component: Favoritos,
            meta: {
                requiresAuth: true,
                showDashboard: true
            }
        },
        {
            path: '/admin',
            name: 'admin',
            component: Admin,
            meta: {
                requiresAuth: true,
                showDashboard: true,
                hideBot: true
            }
        },
        {
            path: '/highlighted',
            name: 'highlight',
            component: Highlight,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'highlighted',
                showDashboard: true
            }
        },
        {
            path: '/admin/property',
            name: 'admin-property',
            component: PropertyAdmin,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'property',
                showDashboard: true
            }
        },
        {
            // Carga de informes por usuario (los ve el property en /informes).
            path: '/admin/informes',
            name: 'admin-informes',
            component: AdminInformes,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'informes',
                showDashboard: true,
                hideBot: true
            }
        },
        {
            path: '/coupon',
            name: 'coupon',
            component: Coupon,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'coupon',
                showDashboard: true
            }
        },
        {
            path: '/icalendar',
            name: 'ical',
            component: Ical,
            meta: {
                requiresAuth: true,
                showDashboard: true,
                hideBot: true
            }
        },
        {
            path: '/visits',
            name: 'visits',
            component: Visits,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'visits',
                showDashboard: true
            }
        },
        {
            path: '/admin/generic-link',
            name: 'admin-generic-link',
            component: GenericLink,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'generic-link',
                showDashboard: true,
                hideBot: true
            }
        },
        {
            path: '/admin/edicion-precios',
            name: 'admin-edicion-precios',
            component: EdicionPrecios,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                showDashboard: true,
                hideBot: true
            }
        },
        {
            // La consola de mensajería. Es a donde apunta "Sophi" en el menú de
            // admin (components/Admin/modules.json) y el deep-link del dashboard
            // de intakes, que entra con ?conversation (DashboardV2.openFromRoute).
            path: '/admin/mensajeria',
            name: 'admin-mensajeria',
            component: DashboardV2,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'mensajeria',
                // A pantalla completa: sin header, sin footer, sin menú de admin
                // y sin el bot. La consola trae su propia salida ("Salir" en la
                // barra superior) y su propia navegación en el espinazo.
                showDashboard: false,
                hideHeader: true,
                hideFooter: true,
                hideBot: true
            }
        },
        {
            // Mientras convivieron las dos consolas, la nueva se entraba por
            // acá. La URL quedó en favoritos y pegada en chats, así que sigue
            // resolviendo. El redirect es una función para no perder la query:
            // un link con ?conversation tiene que seguir abriendo ese chat.
            path: '/admin/mensajeria-nueva',
            redirect: to => ({ path: '/admin/mensajeria', query: to.query })
        },
        {
            path: '/admin/backoffice',
            name: 'admin-backoffice',
            component: BackOffice,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'backoffice',
                showDashboard: true,
                hideBot: true
            }
        },
        {
            // Admin → Usuarios: buscar, ver la actividad y editar cualquier cuenta.
            path: '/admin/usuarios',
            name: 'admin-usuarios',
            component: () => import('@/components/Admin/Usuarios/Usuarios.vue'),
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'usuarios',
                showDashboard: true,
                hideBot: true
            }
        },
        {
            path: '/admin/permisos',
            name: 'admin-permisos',
            component: Permissions,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                requiresSuperAdmin: true,
                moduleKey: 'permissions',
                showDashboard: true,
                hideBot: true
            }
        },
        {
            // Modelos de operación: con cuál trabaja cada anfitrión. Solo super
            // admin: define qué se le cobra al huésped y qué se le retiene al
            // anfitrión.
            path: '/admin/modelos',
            name: 'admin-modelos',
            component: Modelos,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                requiresSuperAdmin: true,
                moduleKey: 'modelos',
                showDashboard: true,
                hideBot: true
            }
        },
        {
            // Inventario → Centro de QA: integraciones en prueba, revisión,
            // integración y horario (QaController, módulo `centro-qa`).
            // /admin/centro-qa             tarjetas de integraciones
            // /admin/centro-qa/historial   corridas anteriores
            // /admin/centro-qa/<clave>     revisión de la corrida de esa integración
            // /admin/centro-qa/<clave>/actual  lo que tiene hoy en la base (solo lectura)
            path: '/admin/centro-qa/:vista?/:sub(actual)?',
            name: 'admin-centro-qa',
            component: () => import('@/components/Admin/CentroQa/CentroQa.vue'),
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'centro-qa',
                showDashboard: true,
                hideBot: true,
                hideFooter: true,
            },
        },
        {
            // Inventario → Oferta disponible: unidades publicadas y disponibles
            // por mes, continente, país y ciudad (OfertaDisponibleService).
            // El estado (vista, mes y filtros) va en la URL; la pantalla maneja
            // su propio scroll (meta.scrollPropio).
            path: '/admin/oferta-disponible/:nivel(c|p)?/:clave?',
            name: 'admin-oferta-disponible',
            component: () => import('@/components/Admin/OfertaDisponible/OfertaDisponible.vue'),
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'oferta-disponible',
                showDashboard: true,
                hideBot: true,
                scrollPropio: true
            }
        },
        {
            // Marketing → Partners: clics en los correos, veces que los eligen
            // en el formulario y entradas con su código (MarketingPartnersController).
            path: '/admin/marketing/partners',
            name: 'admin-marketing-partners',
            component: () => import('@/components/Admin/Marketing/MarketingPartners.vue'),
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'marketing-partners',
                showDashboard: true,
                hideBot: true
            }
        },
        {
            // Marketing → Prospectos de anfitriones: CRM tipo tablero
            // (CrmAnfitrionesController). Sin footer: el tablero ocupa la pantalla.
            path: '/admin/marketing/crm-anfitriones',
            name: 'admin-crm-anfitriones',
            component: () => import('@/components/Admin/CrmAnfitriones/CrmAnfitriones.vue'),
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'crm-anfitriones',
                showDashboard: true,
                hideBot: true,
                hideFooter: true
            }
        },
        {
            // Tableros personales: tableros tipo Notion de cada admin, con
            // permisos por tablero (TablerosController). Sin footer.
            path: '/admin/tableros/:id(\\d+)?',
            name: 'admin-tableros',
            component: () => import('@/components/Admin/Tableros/Tableros.vue'),
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'tableros',
                showDashboard: true,
                hideBot: true,
                hideFooter: true
            }
        },
        {
            path: '/admin/homiii-sync',
            name: 'admin-homiii-sync',
            component: () => import('@/pages/Dashboard/HomiiiSyncPreview.vue'),
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                showDashboard: true,
                hideBot: true
            }
        },

        // Route '/admin/supply-demand-intelligence' removed
        {
            path: '/manage-data',
            name: 'manage-data',
            component: ManageData,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'manage-data',
                showDashboard: true
            }
        },
        
        {
            path: '/dashboard-intakes',
            name: 'dashboard-intakes',
            component: DashboardIntake,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'dashboard-intakes',
                showDashboard: true
            }
        },
        
        {
            path: '/reservations',
            name: 'reservations',
            component: Reservations,
            meta: {
                requiresAuth: true,
                requiresAdmin: true,
                moduleKey: 'reservations',
                showDashboard: true
            }
        },
        {
            path: '/privacidad',
            name: 'Privacy',
            component: Privacy
        },
        {
            path: '/faq',
            name: 'Faq',
            component: Faq
        },
        {
            // Guía pública para integrarse (carga masiva por API, SQL, planilla…).
            path: '/developers',
            name: 'developers',
            component: () => import('@/pages/General/Developers.vue')
        },
        {
            path: '/tyc',
            name: 'TermsConditions',
            component: TermsConditions
        },
        {
            path: '/facebook/delete/:token',
            name: 'facebook-delete',
            component: FacebookDeleteStatus
        },
        {
            // Cualquier dirección que no coincide con una ruta: página 404
            // "Habitación no encontrada". Tiene que quedar SIEMPRE al final.
            // Con el header del sitio; sin footer ni bot (Sophi ocupa la
            // esquina del bot).
            path: '*',
            name: 'not-found',
            component: () => import('@/pages/General/NotFound.vue'),
            meta: {
                hideFooter: true,
                hideBot: true
            }
        }
    ],
    // set custom query resolver
    parseQuery(query) {
        return qs.parse(query);
    },
    stringifyQuery(query) {
        var result = qs.stringify(query);

        return result ? ('?' + result) : '';
    }
})

router.beforeEach((to, from, next) => {
    // Registrar última vista visitada (excluyendo auth y edición de perfil)
    try { saveLastVisitedUrl(to); } catch (e) {}
    // Capturar código de referencia (Generador de links) si viene en la URL.
    // Entrar al registro SIN ?ref ya no lo borra: la persona puede abrir el
    // link, ir a "Iniciar sesión" y volver a "Registrarse". El código vence a
    // los 30 días y se limpia al crear la cuenta (ver Utils/referido.js).
    if (to && to.query && to.query.ref) {
        guardarReferido(to.query.ref);
    }
    
    // Login guard
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            // El usuario property tiene un panel recortado: sus alojamientos, el
            // calendario, sus informes y los datos de la cuenta. Lo demás se
            // esconde del menú y también se corta acá, por si entra a mano.
            // Un admin que además es property (cuentas internas de prueba) no
            // se recorta: si no, cada sección del panel admin lo mandaba a
            // Mis espacios.
            if (store.getters.isProperty && !store.getters.isAdmin) {
                const bloqueadasParaProperty = [
                    'reservations-made',
                    'reservations-received',
                    'favoritos',
                    'Datos bancarios',
                    'ical'
                ];
                const esAdminOnly = to.matched.some(record => record.meta.requiresAdmin);

                if (esAdminOnly || bloqueadasParaProperty.indexOf(to.name) !== -1) {
                    next({ name: 'my-accommodations' });
                    return;
                }
            }

            // Calendario e Informes son solo del property (el admin entra para
            // dar soporte).
            if (
                to.matched.some(record => record.meta.requiresProperty) &&
                !store.getters.isProperty &&
                !store.getters.isAdmin
            ) {
                next({ name: 'my-accommodations' });
                return;
            }

            if (to.matched.some(record => record.meta.requiresAdmin)) {
                if (store.getters.isAdmin) {
                    const protectedRecord = to.matched.find(record => record.meta.moduleKey);
                    const moduleKey = protectedRecord && protectedRecord.meta.moduleKey;
                    // El tilde del módulo manda para todos. Las rutas marcadas
                    // con requiresSuperAdmin suman el requisito de rol.
                    const needsSuperAdmin = to.matched.some(record => record.meta.requiresSuperAdmin);
                    if (needsSuperAdmin && !store.getters.isSuperAdmin) {
                        next('/admin');
                    } else if (store.getters.hasAdminPermission(moduleKey)) {
                        next();
                    } else {
                        next('/admin');
                    }
                } else {
                    next('/');
                }
            } else {
                next();
            }
            return;
        }
        // Save the intended destination so after login/registration
        // the user can be redirected back to where they wanted to go
        if (to.name !== 'login' && to.name !== 'register') {
            saveRedirectUrl(to);
        }
        next('/login');
    } else {
        // Lenguage guard

        // Extract the language from the route parameters
        const lang = to.params.lang;

        if (lang) {
            // Check if the language is in the list of supported languages
            if (!supportedLanguages.includes(lang)) {
                // Redirect to the default language if it's not supported
                return next({path: `/en${to.fullPath.substring(3)}`});
            }

            // Set the language for vue-i18n
            if (lang !== i18n.locale) {
                i18n.locale = lang;  // Dynamically change the language
            }
        }
        
        next();
    }
})


export default router
